var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTickFavourite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.30566 0.949514C8.18461 0.241057 9.09497 -0.0798548 10.3351 0.0168383L10.5276 0.0345204L10.6574 0.0511248C12.5466 0.32073 14.1193 2.01273 14.3834 4.48378L14.4 4.6616L14.3982 5.46122C14.1801 8.27168 12.16 10.9863 8.25427 13.8335L8.00241 14.0154L7.80634 14.1668C7.48328 14.4559 7.02028 14.4752 6.65882 14.2454L6.583 14.1924L6.37415 14.0286C2.39912 11.153 0.311858 8.43837 0.0164251 5.59637L0 5.41479L0.00195813 4.61316C0.210793 2.03442 1.88387 0.245403 3.88462 0.0336592C5.22365 -0.0937566 6.18843 0.22499 7.10178 0.957479L7.1988 1.03712L7.30566 0.949514Z",
    fill: "#E23636"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickFavourite);
export default __webpack_public_path__ + "static/media/tick-favourite.353275891c02060a23f6eb5efcb51ef8.svg";
export { ForwardRef as ReactComponent };